<template>
    <div>
        <input-group icon="fa fa-calendar">
            <v-select class="form-control"
                      v-model="valueModel"
    
                      :options="options"
                      clearable
    
                      label="label"
    
                      close-on-select
            />
        </input-group>
    </div>
</template>

<script>
import api from "@modules/JourneyBuilder/api";
import {bootstrapDangerGrowl} from "@core/Util/growler";

import InputGroup from "@core/Components/Inputs/InputGroup";
import VSelect from 'vue-select';

export default {
    name: "InflowPeriodPicker",
    
    components: {
        InputGroup,
        VSelect
    },
    
    props: {
        value: {
            type: Number,
            required: false
        }
    },
    
    data() {
        return  {
            options: []
        }
    },
    
    computed: {
        valueModel: {
            get() {
                return this.options.find(o => o.id === this.id);
            },
            set(value) {
                this.$emit('input', value && value.id);
            }
        }
    },

    async created() {
        try {
            this.options = await api.getStatisticsInflowPeriods();
        } catch (e) {
            bootstrapDangerGrowl(e);
        }
    }
}
</script>
